import { render, staticRenderFns } from "./proAdd.vue?vue&type=template&id=4272d378&scoped=true&"
import script from "./proAdd.vue?vue&type=script&lang=js&"
export * from "./proAdd.vue?vue&type=script&lang=js&"
import style0 from "./proAdd.vue?vue&type=style&index=0&id=4272d378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4272d378",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4272d378')) {
      api.createRecord('4272d378', component.options)
    } else {
      api.reload('4272d378', component.options)
    }
    module.hot.accept("./proAdd.vue?vue&type=template&id=4272d378&scoped=true&", function () {
      api.rerender('4272d378', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/proAdd.vue"
export default component.exports